export default "__VITE_ASSET__Bxa9DYb4__"